<template>
  <hypto-popup :title="'Bulk Import Confirmation'">
    <template v-slot:body>
      <p>Are you sure you want to process bulk payouts?</p>
      <div class="csv-data">
        <p v-for="(record, index) in csvData" :key="index">
          <b>
            {{record.key}}
            <i v-if="record.info">{{record.info}}</i>
          </b>
          <span>{{record.value}}</span>
        </p>
      </div>
      <error-info :errorList="formErrors.import" />
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="uploadData">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import ErrorInfo from '@/components/global/ErrorInfo'

import ApiServices from '@/services/api/imports'
import { openPopup, amountFormat, checkFormErrors } from '@/utils/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'ImportUploadConfirmation',
  components: { HyptoPopup, ErrorInfo },
  data () {
    return {
      csvData: [],
      formErrors: {
        import: []
      }
    }
  },
  computed: {
    ...mapGetters(['getterSectionDetails'])
  },
  created () {
    this.populateData()
  },
  methods: {
    openPopup,
    amountFormat,
    checkFormErrors,
    populateData () {
      let data = this.getterSectionDetails
      if (!data) {
        this.openPopup(null)
        return
      }

      const appendRow = (key, value, info) => {
        this.csvData.push({key, value, info})
      }

      appendRow('File name', data.file.name)
      appendRow('Transaction type', data.txn_type)
      if (data.csv_validated) {
        appendRow('Total records', data.rows)
        appendRow('Total amount', this.amountFormat(data.amount), data.txn_type === 'BANK_TRANSFERS' ? '(excl. charges & GST)' : null)
        if (data.show_balance) {
          appendRow('Account balance', this.amountFormat(data.balance))
        }
      }
    },
    uploadData () {
      if (!this.checkFormErrors(this.formErrors)) {
        let details = this.getterSectionDetails
        let formData = new FormData()
        formData.append('csv_file', details.file)
        formData.append('txn_type', details.txn_type)
        formData.append('csv_validated', details.csv_validated)

        ApiServices.create(formData).then(response => {
          if (response.success) {
            this.successToastMsg(response.message)
            this.openPopup(null)
            this.$emit('refreshList')
          } else {
            this.errorToastMsg(response.message)
          }
        }).catch(error => {
          this.formErrors = {
            ...this.formErrors,
            ...error.body.reason
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .csv-data {
    width: 80%;
    min-width: 300px;
    max-width: 500px;
    margin: 10px auto;
    border: 2px solid $grey-outline;

    p {
      @include custom-flex(null);

      &:not(:last-child) {
        border-bottom: 2px solid $grey-outline;
      }

      b {
        padding: 8px 10px;
        width: 140px;
        text-align: left;
        border-right: 2px solid $grey-outline;

        i {
          @include normal-text($grey-light, 13px, 400);
          display: block;
        }
      }

      span {
        padding: 8px 12px;
        flex: 1;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
